import links from "@/links/links";

export default {
  actions: {
    POST(formData) {
      return this.post(links.MEDIA_POST(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
    },
    PUT(item) {
      return this.put(links.MEDIA_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.MEDIA_DELETE(item.id), {
        delete: item.id,
      });
    },
    BULK_DELETE(ids) {
      return this.post(links.MEDIA_BULK_DELETE(), {
        ids: ids,
      });
    },
    GET_LOGO_IN_BASE64(id) {
      return this.get(links.MEDIA_GET_IN_BASE64(id), { save: false });
    },
    MANDATE_PDF_CREATE_MERGE(meetingId, templates, mandateId) {
      return this.post(links.MANDATE_PDF_CREATE_MERGE(), {
        meetingId: meetingId,
        templates: templates,
        mandateId: mandateId,
      });
    },
    MANDATE_PDF_CREATE_MERGE_PV(mandateId, meetingId, templates) {
      return this.post(links.MANDATE_PDF_CREATE_MERGE_PV(), {
        mandateId: mandateId,
        meetingId: meetingId,
        templates: templates,
      });
    },
    MEETING_PDF_CREATE_SAVE_RETURN(meetingId, templates) {
      return this.post(links.MEETING_PDF_CREATE_SAVE_RETURN(), {
        meetingId: meetingId,
        templates: templates,
      });
    },
    MEETING_PDF_CREATE_RETURN(meetingId, templates) {
      return this.post(links.MEETING_PDF_CREATE_RETURN(), {
        meetingId: meetingId,
        templates: templates,
      });
    },
    MEDIA_CREATE_FROM_BASE64(item) {
      return this.post(links.MEDIA_CREATE_FROM_BASE64(), item);
    },
    MEDIA_CHECK_PDF_FORMAT(item) {
      return this.post(links.MEDIA_CHECK_PDF_FORMAT(), item, { save: false });
    },
    MEDIA_UPDATE_PDF_POSITION(item) {
      return this.post(links.MEDIA_UPDATE_PDF_POSITION(), item, { save: false });
    },
    CREATE_PDFS_TO_GENERATE_ROW(data) {
      return this.post(
        links.CREATE_PDFS_TO_GENERATE_ROW(),
        {
          meetingId: data.meetingId,
          meetingWithTemplates: data.meetingWithTemplates,
          mandatesWithTemplates: data.mandatesWithTemplates,
          recipientsWithTemplates: data.recipientsWithTemplates,
          generateType: data.generateType,
        },
        { save: false }
      );
    },
    MEDIA_GET_SIGNATURES(meetingId) {
      return this.get(links.MEDIA_GET_SIGNATURES(meetingId) + `?meeting_id=${meetingId}`, {
        dataKey: "hydra:member",
      });
    },
    DUMMY_PDF_CREATE_RETURN(templates) {
      return this.post(links.DUMMY_PDF_CREATE_RETURN(), {
        templates: templates,
      });
    },
  },
};
